<template>
  <div>
    <organizational-structure-menu></organizational-structure-menu>

    <h1>{{ $t("settings.organisationStructure.title") }}</h1>

    <v-alert type="info">
      {{ $t("settings.organisationStructure.alertInfo") }}
    </v-alert>

    <v-treeview :items="items" class="mt-3" item-key="name" item-text="" open-all open-on-click>
      <template slot="prepend" slot-scope="{ item, open, leaf }">
        <v-row
          @contextmenu="
            v => {
              showContextMenu(v, item, leaf);
            }
          "
        >
          <v-icon>
            {{ open ? "mdi-folder-open" : "mdi-folder-account" }}
          </v-icon>
          <v-col
            ><span class="ml-2 font-weight-bold title">{{ item.name }} </span> ({{ item.count_users }}
            <v-icon small>people</v-icon>
            )
          </v-col>
        </v-row>
      </template>
    </v-treeview>

    <v-dialog max-width="500px" persistent v-model="dialog">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("settings.organisationStructure.dialog.headline") }}</span>
        </v-card-title>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <v-text-field
              :label="$t('settings.organisationStructure.dialog.fields.name.name') + '*'"
              :rules="[isRequiredValidation]"
              v-model="currentItem.name"
            >
            </v-text-field>
            <v-text-field
              :label="$t('settings.organisationStructure.dialog.fields.description.name') + '*'"
              :rules="[isRequiredValidation]"
              v-model="currentItem.description"
            >
            </v-text-field>
            <v-tooltip :disabled="currentItem.children.length === 0" bottom>
              <template #activator="{on}">
                <v-select
                  :disabled="currentItem.children.length > 0"
                  :items="availableParents"
                  item-text="name"
                  item-value="id"
                  v-model="currentItem.parent_id"
                  :label="$t('settings.organisationStructure.dialog.fields.parent.name')"
                  v-on="on"
                />
              </template>
              {{ $t("settings.organisationStructure.canNotChangeParentTooltip") }}
            </v-tooltip>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="dialog = false" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid" @click.native="save" color="blue darken-1" text>{{ $t("global.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-menu :position-x="x" :position-y="y" absolute offset-y v-model="showMenu">
      <v-list>
        <v-list-item @click="addNew">
          <v-list-item-title>{{ $t("settings.organisationStructure.contextMenu.addNew") }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="edit">
          <v-list-item-title>{{ $t("settings.organisationStructure.contextMenu.edit") }}</v-list-item-title>
        </v-list-item>
        <v-tooltip bottom :disabled="!(currentItem.children.length !== 0 || currentItem.count_users !== 0 || currentItem.parent_id == null)">
          <template #activator="{on}">
            <v-list-item
              :disabled="currentItem.children.length !== 0 || currentItem.count_users !== 0 || currentItem.parent_id == null"
              @click="remove"
              v-on="on"
            >
              <v-list-item-title>{{ $t("settings.organisationStructure.contextMenu.delete") }}</v-list-item-title>
            </v-list-item>
          </template>
          {{
            currentItem.parent_id === null
              ? $t("settings.organisationStructure.canNotDeleteMainStructureTooltip")
              : $t("settings.organisationStructure.canNotDeleteTooltip")
          }}
        </v-tooltip>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import OrganizationalStructureMenu from "../../../components/Settings/OrganizationalStructureMenu";

export default {
  name: "SettingsOrganizationalStructureView",
  components: { OrganizationalStructureMenu },
  data: () => ({
    formValid: true,
    dialog: null,
    currentItem: {
      id: null,
      name: null,
      cost_centre: null,
      count_users: null,
      parent: null,
      parent_id: null,
      children: []
    },
    organizationStructureList: [],
    showMenu: false,
    x: 0,
    y: 0,
    tree: []
  }),
  created() {
    this.downloadStructure();
  },
  computed: {
    items() {
      return this.getChilds();
    },
    availableParents() {
      return this.organizationStructureList.filter(v => v.id !== this.currentItem.id);
    }
  },
  methods: {
    isRequiredValidation(e) {
      if (e == null || e.length === 0) return this.$t("global.error.required");
      return true;
    },
    getChilds(itemId = null) {
      let items = JSON.parse(JSON.stringify(this.organizationStructureList.filter(v => v.parent_id === itemId)));
      for (let key in items) {
        items[key].children = this.getChilds(items[key].id);
        items[key].parent = this.organizationStructureList.find(v => v.id === items[key].parent_id);
      }
      return items;
    },
    showContextMenu(e, item /*, leaf*/) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.currentItem = JSON.parse(JSON.stringify(item));
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    addNew() {
      this.currentItem = {
        id: null,
        name: null,
        cost_centre: null,
        count_users: null,
        parent: this.currentItem,
        parent_id: this.currentItem.id,
        children: []
      };
      this.dialog = true;
    },
    edit() {
      this.dialog = true;
    },
    remove() {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("global.removeConfirm.content"),
        title: this.$t("global.removeConfirm.title")
      });
      result
        .then(() => {
          this.axios
            .post("settings/organization-structure/delete", {
              id: this.currentItem.id
            })
            .then(() => {
              this.$store.dispatch("snackbarPush", {
                text: this.$t("global.saved"),
                position: "down"
              });
              this.downloadStructure();
            })
            .catch(() => {
              this.$store.dispatch("snackbarPush", {
                text: this.$t("global.error.generalError.content"),
                position: "down"
              });
            });
        })
        .catch(function(resp) {
          console.log(resp);
        });
    },
    downloadStructure() {
      this.axios.get("settings/organization-structure/list").then(resp => {
        this.organizationStructureList = resp.data;
      });
    },
    save() {
      if (this.$refs.form.validate()) {
        this.axios
          .post("settings/organization-structure/save", this.currentItem)
          .then(() => {
            this.downloadStructure();
            this.dialog = false;
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.saved"),
              position: "down"
            });
          })
          .catch(() => {
            //TODO OBSLUGA BLEDOW
          });
      }
    }
  }
};
</script>

<style scoped></style>
